/** A view-owned URL. Persist the Blob, never this temporary presentation address. */
export class ImageSource {
  private media: Blob | string | null = null;
  private url: string | null = null;

  get(media: Blob | string | null): string | null {
    if (media !== this.media) {
      this.clear();
      this.media = media;
      // Existing sessions can still contain their original data-URL thumbnails.
      this.url = media instanceof Blob ? URL.createObjectURL(media) : media;
    }
    return this.url;
  }

  clear(): void {
    if (this.media instanceof Blob && this.url) URL.revokeObjectURL(this.url);
    this.media = null;
    this.url = null;
  }
}
